import { FoodfluenceLocation } from '@foodfluence/shared';

interface LocationInfo {
  address: string;
  locationEmails: string[];
}

export const getFilteredLocations = (locations: FoodfluenceLocation[], searchQuery: string) => {
  if (!locations) return [];
  const query = searchQuery.toLowerCase();
  return locations.filter(location => {
    return location.fullAddress.toLowerCase().includes(query) ||
           location.city.toLowerCase().includes(query) ||
           location.state.toLowerCase().includes(query) ||
           location.zip.toLowerCase().includes(query);
  });
};

export const getLocationInfo = (
  selectedLocation: { docId: string; fullAddress: string } | null,
  locations: FoodfluenceLocation[]
): LocationInfo => {
  let address = '';
  let locationEmails: string[] = [];

  if (selectedLocation && locations) {
    const location = locations.find(loc => loc.docId === selectedLocation.docId);
    if (location) {
      address = `${location.streetNumber} ${location.streetName}, ${location.city}, ${location.state}`;
      locationEmails = location.emails || [];
    }
  }

  return { address, locationEmails };
};